import { waLink } from "@/lib/config";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href={waLink("Hi APEX, I'd like to ask about a Tanzania safari.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Chat on WhatsApp"
    >
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></div>
      <div className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebd5b] text-white pl-5 pr-6 py-4 rounded-full shadow-2xl shadow-black/20 transition-all duration-300 hover:scale-105">
        <MessageCircle size={22} fill="white" />
        <span className="hidden md:inline text-sm font-semibold">Chat with us</span>
      </div>
    </a>
  );
}
